import React, { useEffect, useState } from "react";
import RankService from "../../services/rank.service";
import Loader from "../Common/Loader";
import { Button, Spinner } from "react-bootstrap";
import CommonService from "../../services/common.service";
import StatService from "../../services/stat.service";
import StatsCardModalDownload from "../Stat/StatsCardModalDownload";
import HubCardDownload from "./HubCardDownload";
import GameCardDownload from "./GameCardDownload";
import MyTeamDownloadModal from "./MyTeamDownloadModal";

const MultiCardDownload = (props) => {
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  useEffect(() => {
    if (props.showStatsTab) {
      console.log("check");
    }
  }, [props.showStatsTab]);

  const [loadingStates, setLoadingStates] = useState({}); // Maintain separate loading states for each button

  const [showAccountShareModal, setShowAccountShareModal] = useState(false);
  const [accountDetails, setAccountDetails] = useState({});

  const handleHubCardModalClose = () => setShowAccountShareModal(false);

  const hubCardDownload = (type) => {
    setLoadingStates((prev) => ({ ...prev, [type]: true }));
    CommonService.getAccountDetail()
      .then((res) => {
        if (res.status === 200) {
          setAccountDetails(res.data);
          setShowAccountShareModal(true);
        }
      })
      .finally(() => {
        setLoadingStates((prev) => ({ ...prev, [type]: false })); // Stop loading for the specific type
      });
  };

  //   Game Card Modal
  const [showGameShareModal, setShowGameShareModal] = useState(false);
  const [itemDetail, setItemDetail] = useState({});
  const handleGameCardModalClose = () => setShowGameShareModal(false);
  const gameCardDownload = (type) => {
    setLoadingStates((prev) => ({ ...prev, [type]: true }));
    CommonService.getAccountDetail()
      .then((res) => {
        if (res.status === 200) {
          setAccountDetails(res.data);
          setItemDetail(res.game_details);
          setShowGameShareModal(true);
        }
      })
      .finally(() => {
        setLoadingStates((prev) => ({ ...prev, [type]: false })); // Stop loading for the specific type
      });
  };
  //   Game Card Modal
  const [teamModalData, setTeamModalData] = useState({});
  const [showTeamCardModal, setShowTeamCardModal] = useState(false);
  const handleMyTeamCardModalClose = () => setShowTeamCardModal(false);
  const myTeamCardDownload = (type, gameId) => {
    setLoadingStates((prev) => ({ ...prev, [type]: true }));
    CommonService.getTeamCardDetail(gameId)
      .then((res) => {
        if (res.status === 200) {
          const data = {};
          data.my_team_name = res.data?.my_team_name;
          data.current_round = res?.lastRoundDetails?.round;
          data.rank_points = res?.rank_points;
          data.avgPoints = res?.avgPoints;
          data.game_info_block_data = res?.gameInfoBlockData;
          data.clubDetails = res?.clubDetails;
          data.budget_used = res?.budget_used;
          data.budget_left = res?.budget_left;
          data.full_name = res?.userDetails;
          console.log("total value", res?.budget_left + res?.budget_used);
          setTeamModalData(data);
          setShowTeamCardModal(true);
        }
      })
      .finally(() => {
        setLoadingStates((prev) => ({ ...prev, [type]: false })); // Stop loading for the specific type
      });
  };

  return (
    <>
      <div className="customscroll rankcustomscroll">
        <table className="table ranktable rankNewTableClass">
          <thead>
            <tr>
              <th>Type</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Hub Card</td>
              <td style={{ textAlign: "center" }}>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => hubCardDownload("hub_card")}
                >
                  {loadingStates["hub_card"] ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Loading...
                    </>
                  ) : (
                    "Download"
                  )}
                </Button>
              </td>
            </tr>
            <tr>
              <td>Game Card</td>
              <td style={{ textAlign: "center" }}>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => gameCardDownload("game_card")}
                >
                  {loadingStates["game_card"] ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Loading...
                    </>
                  ) : (
                    "Download"
                  )}
                </Button>
              </td>
            </tr>
            <tr>
              <td>My Team Card</td>
              <td style={{ textAlign: "center" }}>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() =>
                    myTeamCardDownload("my_team_card", clubDetails?.id)
                  }
                >
                  {loadingStates["my_team_card"] ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Loading...
                    </>
                  ) : (
                    "Download"
                  )}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <HubCardDownload
        showAccountShareModal={showAccountShareModal}
        setShowAccountShareModal={setShowAccountShareModal}
        accountDetails={accountDetails}
        handleHubCardModalClose={handleHubCardModalClose}
        loadingStates={loadingStates}
      />
      <GameCardDownload
        showGameShareModal={showGameShareModal}
        setShowGameShareModal={setShowGameShareModal}
        itemDetail={itemDetail}
        accountDetails={accountDetails}
        loadingStates={loadingStates}
        handleGameCardModalClose={handleGameCardModalClose}
      />
      <MyTeamDownloadModal
        showTeamCardModal={showTeamCardModal}
        setShowTeamCardModal={setShowTeamCardModal}
        teamModalData={teamModalData}
        loadingStates={loadingStates}
        handleMyTeamCardModalClose={handleMyTeamCardModalClose}
      />
    </>
  );
};

export default MultiCardDownload;
